import { render, staticRenderFns } from "./AddGroupNumber.vue?vue&type=template&id=0507a78e&scoped=true"
import script from "./AddGroupNumber.vue?vue&type=script&lang=js"
export * from "./AddGroupNumber.vue?vue&type=script&lang=js"
import style0 from "./AddGroupNumber.vue?vue&type=style&index=0&id=0507a78e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0507a78e",
  null
  
)

export default component.exports